import { normalizeElement } from './normalize-element'

export const normalizeCatalog = (rawData) => {
  const {
    description = '',
    id = '',
    refresh = '',
    element_list: elementList = []
  } = rawData

  return {
    description,
    id,
    refresh,
    elementList: elementList?.map(normalizeElement)
  }
}
